<template>
  <div>
    <BaseButton theme="default"
                class="w-full"
                @click="openModal = true">
    <span class="flex items-center justify-center">
        <font-awesome-icon icon="file-upload" class="text-icon"/>
        <span class="ml-4 text-sm font-medium">{{ $t('importAnotherSpace') }}</span>
      </span>
    </BaseButton>
    <SpaceImportModal v-if="openModal" @close="openModal=false"/>
  </div>
</template>

<script>
import SpaceImportModal from "@/components/cabinet/SpaceSettings/SpaceImport/SpaceImportModal";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "SpaceImport",
  components: {BaseButton, SpaceImportModal},
  data() {
    return {
      openModal: false
    }
  },
  i18n: {
    messages: {
      en: {
        importAnotherSpace: 'Import workspace'
      },
      ru: {
        importAnotherSpace: 'Импорт пространства',
      }
    }
  }
}
</script>